import styled from "styled-components";

export const ViewChooserNav = styled.nav`
  margin-top: var(--outerMargin);
  & > a {
    border: 1px solid var(--linkColor);
    padding: 4px 8px;
    background-color: var(--white);
    user-select: none;
    transition: 0.5s;
    &.selected {
      color: var(--white);
      background-color: var(--linkColor);
    }
    & + a {
      margin-left: 8px;
    }
  }
`;

export const ViewWrapper = styled.div`
  margin-top: var(--outerMargin);
  margin-bottom: var(--outerMargin);
  margin-left: ${(props) =>
    props.timeline ? 0 : "calc(0px - var(--outerMargin))"};
`;
